import dayjs from 'dayjs'

export const PERIOD_KEYS = ['today', 'week', 'month', 'all']

const num = value => (Number.isFinite(Number(value)) ? Number(value) : 0)

export const rateOf = (value, total) => (total ? (num(value) / num(total)) * 100 : null)

export const sumRows = rows =>
  (rows ?? []).reduce((acc, row) => {
    Object.entries(row ?? {}).forEach(([key, value]) => {
      if (value !== null && value !== '' && Number.isFinite(Number(value))) {
        acc[key] = (acc[key] ?? 0) + Number(value)
      }
    })
    return acc
  }, {})

export const summarise = (rows, { dateField = 'date', valueField = 'value', totalField = 'total' } = {}) => {
  const days = [...(rows ?? [])]
    .filter(row => row?.[dateField])
    .sort((a, b) => String(a[dateField]).localeCompare(String(b[dateField])))

  if (!days.length) return null

  const today = dayjs().format('YYYY-MM-DD')
  const dateOf = row => String(row[dateField]).slice(0, 10)
  const asOf = days.some(row => dateOf(row) === today) ? today : dateOf(days[days.length - 1])
  const anchor = dayjs(asOf)

  const since = {
    today: asOf,
    week: anchor.startOf('week').format('YYYY-MM-DD'),
    month: anchor.startOf('month').format('YYYY-MM-DD'),
    all: dateOf(days[0]),
  }

  const periods = Object.fromEntries(
    PERIOD_KEYS.map(key => {
      const scoped = days.filter(row => dateOf(row) >= since[key] && dateOf(row) <= asOf)
      const sums = sumRows(scoped)
      return [
        key,
        { sums, value: sums[valueField] ?? 0, total: sums[totalField] ?? 0, rate: rateOf(sums[valueField], sums[totalField]), days: scoped.length },
      ]
    }),
  )

  return { days, dateOf, asOf, isCurrent: asOf === today, periods, baseline: periods.all.rate }
}

export const trendOf = (days, { dateOf, valueField = 'value', totalField = 'total', limit = 20 } = {}) =>
  (days ?? [])
    .slice(-limit)
    .map(row => ({ date: dateOf ? dateOf(row) : row.date, rate: rateOf(row[valueField], row[totalField]) }))
    .filter(point => point.rate !== null)
